import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Box, NakedButton } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const QffMenuWrapper = styled(Flex)`
  position: fixed;
  top: 74px;
  right: 0;
  left: 0;
  bottom: 0;
  flex-direction: column;
  will-change: transform;
  transition: all 0.2s ease-in-out;
  background-color: ${themeGet('colors.white')};
  z-index: ${themeGet('zIndices.phoneMenuDrawerClose')};
  border-top: ${themeGet('space.2')} solid ${themeGet('colors.brand.primary')};

  ${mediaQuery.minWidth.sm} {
    transition: null;
    width: 35%;
    left: auto;
    bottom: auto;
  }
`;

export const LogOutButton = styled(Flex)`
  padding-bottom: ${themeGet('space.4')};
  border-bottom: 2px solid ${themeGet('colors.greys.porcelain')};
`;

export const QffMenuButtonWrapper = styled(Box)`
  cursor: pointer;
`;

export const QffMenuButton = styled(NakedButton)`
  height: 74px;
  width: 80px;
  padding: ${themeGet('space.4')} 0;
  background-color: ${themeGet('colors.brand.primary')};
  color: ${themeGet('colors.white')};
  align-items: center;
  justify-content: center;
`;
